import React from 'react';

const About = function () {
    return <div className="about view pt-20 pb-20">
        <h2 className="pb-10">About</h2>
        <p className="pb-5">A tool to encode subject line with emojis or any special characters.</p>
        <p className="pb-5">Copy emojis from your favorite emoji site such as: <a className="link" href="https://getemoji.com/">Get Emoji</a> and paste it into the decoded string textfield.</p>
    </div>;
}

export default About;